export const VisitStatus = Object.freeze({
	Unknown: 'unknown',
	Visited: 'visited',
	NotVisited: 'notVisited',
});
